export default __webpack_public_path__ + "static/media/Contact.96a6adf2.svg";